"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiTime = void 0;
var tz_offset_1 = require("./tz-offset");
var ApiTime = /** @class */ (function () {
    function ApiTime(date) {
        // check that the date is in the expected format
        if (ApiTime.re1.test(date)) {
            var _a = ApiTime.re1.exec(date), fullDate = _a[0], localDate = _a[1], offset = _a[2];
            this.fullDate = fullDate;
            this.localDate = localDate;
            this.time = new Date(this.fullDate).getTime();
            this.tzOffset = new tz_offset_1.TimezoneOffset(offset);
        }
        else if (ApiTime.re2.test(date)) {
            var _b = ApiTime.re2.exec(date), fullDate = _b[0], localDate = _b[1];
            this.fullDate = fullDate.replace('Z', '+00:00');
            this.localDate = localDate;
            this.time = new Date(this.fullDate).getTime();
            this.tzOffset = new tz_offset_1.TimezoneOffset(0);
        }
        else {
            throw { error: 'Expected date format ' + ApiTime.momentFormat, context: date };
        }
    }
    /**
     * This regex is used to capture dates in the format retured by the API ("2017-09-22T12:25:52.000-05:00")
     * The first capture group is the local date, the second capture group is the timezone offset.
     */
    ApiTime.re1 = /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3})([+-]\d{2}:\d{2})$/;
    ApiTime.re2 = /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3})Z$/; // assumed UTC time
    ApiTime.momentFormat = 'YYYY-MM-DDTHH:mm:ss.SSSZ';
    return ApiTime;
}());
exports.ApiTime = ApiTime;
